'use client';
var classes = {"root":"m_9814e45f"};

export { classes as default };
//# sourceMappingURL=Overlay.module.css.mjs.map
